import { render, staticRenderFns } from "./AppReviewInfoSectionBoard.vue?vue&type=template&id=c505681c&scoped=true"
import script from "./AppReviewInfoSectionBoard.vue?vue&type=script&lang=js"
export * from "./AppReviewInfoSectionBoard.vue?vue&type=script&lang=js"
import style0 from "./AppReviewInfoSectionBoard.vue?vue&type=style&index=0&id=c505681c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c505681c",
  null
  
)

export default component.exports